// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.singlefamilyenterprise.properties.RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId } from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface CustomerIdParams {
  customerId: string;
  listingAlias: ListingAlias;
}

export interface RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Args {
  getParams: CustomerIdParams;
}

export type RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Args
>;

/**
 * Edit single family enterprise contract customerId for a listing
 */
export const useRentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Args) =>
      RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId(args.getParams, httpClient),
  });
};
